var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentTag,_vm._g(_vm._b({tag:"component",class:_vm.clsx('smart-link', {
    'is-disabled': _vm.disabled,
    'is-inactive': _vm.isInactive
  }),on:{"click":_vm.handleClick,"touchend":_vm.handleClick}},'component',_vm.componentAttributes,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }